import { NavLink } from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';

function Navigation() {
    return (
        <NavigationStyled>
            <div className="container-fluid">
                <div className="icons">
                    <NavLink to="/home" className={(navData) => navData.isActive ? "active" : "" }> 
                        <i className="fas fa-house-user"></i>
                    </NavLink>
                    <NavLink to="/about" className={(navData) => navData.isActive ? "active" : "" }> 
                        <i className="fas fa-address-card"></i> 
                    </NavLink>
                    <NavLink to="/resume" className={(navData) => navData.isActive ? "active" : "" }> 
                        <i className="fab fa-accusoft"></i> 
                    </NavLink>
                    <NavLink to="/projects" className={(navData) => navData.isActive ? "active" : "" }> 
                        <i className="fas fa-briefcase"></i> 
                    </NavLink>
                    <NavLink to="/contact" className={(navData) => navData.isActive ? "active" : "" }> 
                        <i className="fas fa-address-book"></i> 
                    </NavLink>
                </div>
            </div>
        </NavigationStyled>
    )
}

const NavigationStyled = styled.nav`
width: 50px;
height: 100vh;
display: flex;
align-items: center;
.icons {
    .active {
        i {
            color: var(--white-color);
            transition: ease-out .5s;
            transform: scale(2);
            margin-left: 10px;
        }
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
    i {
        margin: 15px 0 15px 5px;
        font-size: 25px;
        color: var(--border-color);
    }
}


.icons{
    i:hover {
        transition: ease-out .5s;
        transform: scale(2);
        margin-left: 10px;
    }
}


`;
export default Navigation
